module.exports = __webpack_public_path__ + "static/media/btn_lock.c63f039d.svg";